<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div class="flex items-start justify-between border-b-2 border-teal pb-4 mb-6">
    <!-- Left: icon + title + subtitle -->
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-2">
        <i v-if="icon" :class="[icon, 'text-teal text-xl']" />
        <h1 class="text-2xl font-bold text-navy">{{ title }}</h1>
      </div>
      <p v-if="subtitle" class="text-xs text-[#5A6A7A]">{{ subtitle }}</p>
    </div>

    <!-- Right: actions slot -->
    <div class="flex items-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>
